import { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { useCallback, useEffect, useState } from 'react';

export function useReorderableList<T extends { id: string }>(initialItems: T[]) {
  const [orderedItems, setOrderedItems] = useState<T[]>(initialItems);

  // Sync local state when external items change
  useEffect(() => {
    if (initialItems?.length) setOrderedItems(initialItems);
  }, [initialItems]);

  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event;
      if (!over || active.id === over.id) return;

      const oldIndex = orderedItems.findIndex((item) => item.id === active.id);
      const newIndex = orderedItems.findIndex((item) => item.id === over.id);
      if (oldIndex === -1 || newIndex === -1) return;

      const updated = arrayMove(orderedItems, oldIndex, newIndex);
      setOrderedItems(updated);
    },
    [orderedItems]
  );

  return {
    orderedItems,
    setOrderedItems,
    handleDragEnd,
  };
}
